// @generated by protoc-gen-connect-query v2.1.1 with parameter "target=ts"
// @generated from file bff/v1/admin.proto (package bff.v1, syntax proto3)
/* eslint-disable */

import { BffAdminService } from "./admin_pb";

/**
 * @generated from rpc bff.v1.BffAdminService.SendInvitation
 */
export const sendInvitation = BffAdminService.method.sendInvitation;

/**
 * @generated from rpc bff.v1.BffAdminService.GetMember
 */
export const getMember = BffAdminService.method.getMember;

/**
 * @generated from rpc bff.v1.BffAdminService.SaveMember
 */
export const saveMember = BffAdminService.method.saveMember;

/**
 * @generated from rpc bff.v1.BffAdminService.AgreeToTerm
 */
export const agreeToTerm = BffAdminService.method.agreeToTerm;

/**
 * @generated from rpc bff.v1.BffAdminService.ListPendingTerms
 */
export const listPendingTerms = BffAdminService.method.listPendingTerms;

/**
 * 全体送付先 + プロダクト個別送付先の一覧を取得する
 *
 * @generated from rpc bff.v1.BffAdminService.ListBillingEmails
 */
export const listBillingEmails = BffAdminService.method.listBillingEmails;

/**
 * 全体送付先 + プロダクト個別送付先をまとめて保存する
 *
 * @generated from rpc bff.v1.BffAdminService.SaveBillingEmails
 */
export const saveBillingEmails = BffAdminService.method.saveBillingEmails;

/**
 * プロダクト個別送付先を設定可能なプロダクト一覧を取得する
 * (組織が有効なベースプランを契約しており、かつ請求書送付先設定が有効なプロダクト)
 *
 * @generated from rpc bff.v1.BffAdminService.ListBillingEmailEnabledProducts
 */
export const listBillingEmailEnabledProducts = BffAdminService.method.listBillingEmailEnabledProducts;

/**
 * @generated from rpc bff.v1.BffAdminService.ResetMultifactorAuthentication
 */
export const resetMultifactorAuthentication = BffAdminService.method.resetMultifactorAuthentication;

/**
 * @generated from rpc bff.v1.BffAdminService.UnlockAccount
 */
export const unlockAccount = BffAdminService.method.unlockAccount;

/**
 * 新基盤(M2M)APIキーの一覧を取得する(組織IDはリクエストコンテキストから解決)
 *
 * @generated from rpc bff.v1.BffAdminService.ListApiKeys
 */
export const listApiKeys = BffAdminService.method.listApiKeys;

/**
 * 新基盤(M2M)APIキーの詳細を取得する(自組織のキーのみ)
 *
 * @generated from rpc bff.v1.BffAdminService.GetApiKey
 */
export const getApiKey = BffAdminService.method.getApiKey;

/**
 * 新基盤(M2M)APIキーに付与できるロールの一覧を取得する
 *
 * @generated from rpc bff.v1.BffAdminService.ListApiKeyRoles
 */
export const listApiKeyRoles = BffAdminService.method.listApiKeyRoles;

/**
 * 新基盤(M2M)APIキーに付与できるロールをロールIDで取得する(内部用・非推奨・契約外スコープのロールは NotFound)
 *
 * @generated from rpc bff.v1.BffAdminService.GetApiKeyRole
 */
export const getApiKeyRole = BffAdminService.method.getApiKeyRole;

/**
 * 新基盤(M2M)APIキーを発行する(組織IDはリクエストコンテキストから解決)
 * raw_key は発行時の1回のみレスポンスに含まれ、以後取得できない
 *
 * @generated from rpc bff.v1.BffAdminService.CreateApiKey
 */
export const createApiKey = BffAdminService.method.createApiKey;

/**
 * 新基盤(M2M)APIキーの名前・ロール・有効期限を変更する(自組織のキーのみ)
 *
 * @generated from rpc bff.v1.BffAdminService.UpdateApiKey
 */
export const updateApiKey = BffAdminService.method.updateApiKey;

/**
 * 新基盤(M2M)APIキーを即時失効させる(自組織のキーのみ)。失効後は元に戻せない
 *
 * @generated from rpc bff.v1.BffAdminService.RevokeApiKey
 */
export const revokeApiKey = BffAdminService.method.revokeApiKey;

/**
 * アカウントを一時停止（サスペンド）する
 *
 * @generated from rpc bff.v1.BffAdminService.SuspendMember
 */
export const suspendMember = BffAdminService.method.suspendMember;

/**
 * アカウントの一時停止を解除する
 *
 * @generated from rpc bff.v1.BffAdminService.UnsuspendMember
 */
export const unsuspendMember = BffAdminService.method.unsuspendMember;
